import ApiService from '@/services/core/api.service'

const StatisticsService = {
  async getGeneralInformation (query) {
    return ApiService.get(`shared/statistics/general-information?${query}`)
  }
}

export default StatisticsService
